export default __webpack_public_path__ + "static/media/insta.b0bb0ea2.jpg";